<template>

  <header class="flex flex-col items-center justify-center h-screen bg-cover bg-center bg-no-repeat" :style="{ backgroundImage: 'url(' + require(`@/assets/background.png`) + ')' }">
    <div class="flex flex-col items-center justify-center flex-grow gap-7" style="font-family: PantonRegular;">
      <img class="object-contain h-auto max-w-[1000px]" src="@/assets/logo.png" />
      
      <div class="bg-white p-14 rounded-xl text-2xl text-center max-w-[1000px]">
      <label class="font-bold text-4xl">CUPO COMPLETO</label><br/><br/>
      Gracias por tu interés en participar del Foro de Inversiones Vaca Muerta. El evento ya tiene su capacidad completa.<br/><br/>
      Podrás seguir todo el evento vía streaming.<br/>
      Anotate en <a href="www.forovacamuerta.com/streaming" target="_blank" class="text-blue-500 underline">www.forovacamuerta.com/streaming</a></div>

    </div>
  </header>


</template>
  
